import { createJitsiLinks } from '@/api/jitsi';

export interface GenerateJitsiMeetingLinksParams {
  clientId: string;
  ownerEmail: string;
  ownerName: string;
  memberEmail: string;
  memberName: string;
  roomName?: string;
}

export interface GeneratedJitsiMeetingLinks {
  /** Guest / member join URL */
  meetingUrl: string;
  /** Owner / moderator join URL */
  meetingModeratorUrl: string;
}

/**
 * Create owner + member Jitsi meeting URLs via the SPA server API.
 */
export async function generateJitsiMeetingLinks(
  params: GenerateJitsiMeetingLinksParams
): Promise<GeneratedJitsiMeetingLinks> {
  const { clientId, ownerEmail, ownerName, memberEmail, memberName, roomName } = params;

  const data = await createJitsiLinks(clientId, { ownerEmail, ownerName, memberEmail, memberName, roomName });

  return {
    meetingUrl: data.memberLink,
    meetingModeratorUrl: data.ownerLink
  };
}
